import { render } from "./SidebarLinkComp.vue?vue&type=template&id=2f4a5416&scoped=true&ts=true"
import script from "./SidebarLinkComp.vue?vue&type=script&lang=ts"
export * from "./SidebarLinkComp.vue?vue&type=script&lang=ts"

import "./SidebarLinkComp.vue?vue&type=style&index=0&id=2f4a5416&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\user\\Documents\\Code\\VSProjects\\modboxProject\\modbox\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f4a5416"]])

export default __exports__